export const SET_MENU_CLICKED = "SET_MENU_CLICKED";
export const RESET_MENU_CLICKED = 'SET_RESET_MENU_CLICKED';
export const SET_LOADING = "SET_LOADING";
export const SET_SIDE_MENU = 'SET_SIDE_MENU';
